import React from "react"

interface VideoProps {
  videoId?: string | undefined // Optional to handle undefined cases
  videoTitle?: string | undefined // Optional to handle undefined cases
  [key: string]: any // Allows additional props
}

const SuccessVideos: React.FC<VideoProps> = ({
  videoId,
  videoTitle = "YouTube Video",
  ...props
}) => {
  if (!videoId) return null // Prevents rendering if videoId is undefined

  const videoSrcURL = `https://www.youtube.com/embed/${videoId}`

  return (
    <div className="success-video-container" {...props}>
      <iframe
        src={videoId}
        title={videoTitle}
        className="success-video-frame"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        allowFullScreen
      />
      <div className="success-video-frame success-video-testimony">
        <p dangerouslySetInnerHTML={{ __html: videoTitle }} />
      </div>
    </div>
  )
}

export default SuccessVideos
